export default "__VITE_ASSET__C6Z8IZWY__"